import React, { useEffect, useState } from 'react'
import StepSetting from './StepSetting'
import StepComplete from './StepComplete'
import StepDiamond from './StepDiamond'
import { IDiamond } from 'types/diamond.types'
import { Product, ProductVariant } from '@commerce/types/product'
import ArrowStepIndicatorLightLight from '@components/yadav/icons/ArrowStepIndicatorLightLight'
import ArrowStepIndicatorDarkLight from '@components/yadav/icons/ArrowStepIndicatorDarkLight'
import ArrowStepIndicatorDarkDark from '@components/yadav/icons/ArrowStepIndicatorDarkDark'
import ArrowStepIndicatorLightDark from '@components/yadav/icons/ArrowStepIndicatorLightDark'
import ArrowStepIndicatorLightDarkMobile from '@components/yadav/icons/ArrowStepIndicatorLightDarkMobile'
import ArrowStepIndicatorDarkLightMobile from '@components/yadav/icons/ArrowStepIndicatorDarkLightMobile'
import ArrowStepIndicatorDarkDarkMobile from '@components/yadav/icons/ArrowStepIndicatorDarkDarkMobile'
import ArrowStepIndicatorLightLightMobile from '@components/yadav/icons/ArrowStepIndicatorLightLightMobile'
import { useRouter } from 'next/router'
import cn from 'clsx'
import commerce from '@lib/api/commerce'

const StepIndicator = ({
  startWith,
  className,
  ssrProductData,
  ssrDiamondData,
}: {
  startWith?: 'setting' | 'diamond' | string
  className?: string
  ssrProductData?: Product // Only for SEO purposes
  ssrDiamondData?: IDiamond // Only for SEO purposes
}) => {
  const [isActiveSetting, setIsActiveSetting] = useState(true)
  const [isActiveDiamond, setIsActiveDiamond] = useState(false)
  const [isActiveComplete, setIsActiveComplete] = useState(false)
  const [chosenSetting, setChosenSetting] = useState(false)
  const [chosenDiamond, setChosenDiamond] = useState(false)
  const [choosingSetting, setChoosingSetting] = useState(false)
  const [choosingDiamond, setChoosingDiamond] = useState(false)
  const [myDiamond, setMyDiamond] = useState<IDiamond>()
  const [mySetting, setMySetting] = useState<ProductVariant>()
  const { pathname, query } = useRouter()
  let myPath: String[] = pathname.split('/')
  useEffect(() => {
    if (myPath.includes('[...permalinks]') || myPath.includes('product')) {
      setIsActiveSetting(true)
      setIsActiveDiamond(false)
      setIsActiveComplete(false)
    } else if (
      myPath.includes('diamond') ||
      myPath.includes('lab-created-diamonds') ||
      myPath.includes('natural-loose-diamonds')
    ) {
      setIsActiveSetting(false)
      setIsActiveDiamond(true)
      setIsActiveComplete(false)
    } else {
      setIsActiveSetting(false)
      setIsActiveDiamond(false)
      setIsActiveComplete(true)
    }
  }, [myPath])
  useEffect(() => {
    try {
      let itemLocal = window.localStorage.getItem('setting')
      let itemDiamondLocal = window.localStorage.getItem('diamond')
      if (itemLocal) {
        let settingLocal: ProductVariant = JSON.parse(itemLocal)
        setMySetting(settingLocal)
        setChosenSetting(true)
        setChoosingSetting(false)
      } else {
        setChosenSetting(false)
        setChoosingSetting(true)
      }
      if (itemDiamondLocal) {
        let diamondLocal: IDiamond = JSON.parse(itemDiamondLocal)
        setMyDiamond(diamondLocal)
        setChosenDiamond(true)
        setChoosingDiamond(false)
      } else {
        setChosenDiamond(false)
        setChoosingDiamond(true)
      }
    } catch (error) {
      console.log(error)
    }
  }, [startWith, isActiveDiamond, isActiveSetting, isActiveComplete])

  /*
  ---> startWith === Diamond
  CASE 1: DIAM > sett > cplt
  CASE 2: diam > SETT > cplt
  CASE 3: diam > sett > CPLT

  ---> startWith !== Diamond
  CASE 4: SETT > diam > cplt
  CASE 5: sett > DIAM > cplt
  CASE 6: sett > diam > CPLT
  */

  useEffect(() => {
    const { ring } = query

    if (ring && typeof ring === 'string') {
      commerce
        .getProductVariant({
          variables: { slug: ring, imagesSize: '600x600' },
        })
        .then((res) => {
          if (res.variant) {
            setMySetting(res.variant)
            setChosenSetting(true)
            setChoosingSetting(false)
            window.localStorage.setItem('setting', JSON.stringify(res.variant))
          } else {
            window.localStorage.removeItem('setting')
          }
        })
        .catch(() => window.localStorage.removeItem('setting'))
    }
  }, [query])

  return (
    <div
      className={cn(
        className,
        'flex flex-row border border-gray-100 max-h-[154px]'
      )}
    >
      <div className="flex flex-1 flex-row justify-between bg-white mt-1 md:mt-0 mlg:hidden">
        <div className="relative flex flex-col justify-center items-center w-full md:flex-row md:justify-around lg:px-4 lg:justify-between">
          <p className="flex flex-col items-start text-base font-semibold text-gray-dark">
            Create Your Ring
          </p>
        </div>
        {isActiveDiamond && startWith === 'diamond' ? (
          <>
            <div className="hidden md:flex md:relative md:left-[1px]">
              <ArrowStepIndicatorLightLight width={'24'} height={'67'} />
            </div>
            <div className="flex relative md:hidden">
              <ArrowStepIndicatorLightLightMobile width={'10'} height={'47'} />
            </div>
          </>
        ) : startWith !== 'diamond' && isActiveSetting ? (
          <>
            <div className="hidden md:flex md:relative md:left-[1px]">
              <ArrowStepIndicatorLightLight width={'24'} height={'67'} />
            </div>
            <div className="flex relative md:hidden">
              <ArrowStepIndicatorLightLightMobile width={'10'} height={'47'} />
            </div>
          </>
        ) : (
          <>
            <div className="hidden md:flex md:relative md:left-[1px]">
              <ArrowStepIndicatorLightDark width={'24'} height={'67'} />
            </div>
            <div className="flex relative md:hidden">
              <ArrowStepIndicatorLightDarkMobile width={'10'} height={'47'} />
            </div>
          </>
        )}
      </div>
      <>
        {startWith === 'diamond' ? (
          <>
            <div className="flex flex-1 flex-row justify-between md:pr-0">
              <StepDiamond
                active={isActiveDiamond}
                choosing={choosingDiamond}
                chosen={chosenDiamond}
                diamondData={myDiamond}
                startWith={startWith}
              />
            </div>
            <div className="flex flex-row justify-between bg-gray-100">
              {isActiveSetting && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkLight width={'24'} height={'67'} />
                  </div>
                  {/* shape btw diam & sett, case 2 */}
                  <div className="flex relative md:hidden left-[5px]">
                    <ArrowStepIndicatorDarkLightMobile
                      width={'13'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
              {isActiveDiamond && (
                <>
                  <div className="hidden md:flex md:relative md:left-[-1px]">
                    <ArrowStepIndicatorLightDark width={'24'} height={'67'} />
                  </div>
                  {/* shape btw diam & sett, case 1 */}
                  <div className="flex relative md:hidden left-[-5px]">
                    <ArrowStepIndicatorLightDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}

              {isActiveComplete && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkDark width={'24'} height={'67'} />
                  </div>
                  {/* shape btw diam & sett, case 3 */}
                  <div className="flex relative md:hidden">
                    <ArrowStepIndicatorDarkDarkMobile
                      width={'13'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex flex-1 flex-row justify-between">
              <StepSetting
                active={isActiveSetting}
                choosing={choosingSetting}
                chosen={chosenSetting}
                productData={mySetting}
                startWith={startWith}
              />
            </div>
            <div className="flex flex-row justify-between bg-gray-100">
              {isActiveSetting && (
                <>
                  <div className="hidden md:flex md:relative md:left-[-1px] ">
                    <ArrowStepIndicatorLightDark width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & cplt, case 2 */}
                  <div className="flex relative md:hidden left-[-5px]">
                    <ArrowStepIndicatorLightDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
              {isActiveDiamond && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkDark width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & cplt, case 1 */}
                  <div className="flex relative md:hidden">
                    <ArrowStepIndicatorDarkDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
              {isActiveComplete && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkLight width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & cplt, case 3 */}
                  <div className="flex relative md:hidden">
                    <ArrowStepIndicatorDarkLightMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex flex-1 flex-row justify-between">
              <StepComplete active={isActiveComplete} />
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-1 flex-row justify-between">
              <StepSetting
                active={isActiveSetting}
                choosing={choosingSetting}
                chosen={chosenSetting}
                productData={mySetting}
                startWith={startWith}
              />
            </div>
            <div className="flex flex-row justify-between bg-gray-100">
              {isActiveSetting && (
                <>
                  <div className="hidden md:flex md:relative md:left-[-1px] ">
                    <ArrowStepIndicatorLightDark width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & diam, case 4 */}
                  <div className="flex relative md:left-0 md:hidden left-[-5px]">
                    <ArrowStepIndicatorLightDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
              {isActiveDiamond && startWith === 'diamond' && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkDark width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & diam, case 1 */}
                  <div className="flex relative md:hidden">
                    <ArrowStepIndicatorDarkDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
              {isActiveComplete && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkDark width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & diam, case 6 */}
                  <div className="flex relative md:hidden left-[5px]">
                    <ArrowStepIndicatorDarkDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
              {isActiveDiamond && startWith !== 'diamond' && (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkLight width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & diam, case 5 */}
                  <div className="flex relative md:hidden left-[5px]">
                    <ArrowStepIndicatorDarkLightMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex flex-1 flex-row justify-between">
              <StepDiamond
                active={isActiveDiamond}
                choosing={choosingDiamond}
                chosen={chosenDiamond}
                diamondData={myDiamond}
                startWith={startWith}
              />
            </div>
            <div className="flex flex-row justify-between bg-gray-100">
              {isActiveDiamond && startWith !== 'diamond' ? (
                <>
                  <div className="hidden md:flex md:relative md:left-[-1px] ">
                    <ArrowStepIndicatorLightDark width={'24'} height={'67'} />
                  </div>
                  {/* shape diam & cplt, case 5 */}
                  <div className="flex relative md:hidden left-[-5px]">
                    <ArrowStepIndicatorLightDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              ) : isActiveSetting && startWith === 'diamond' ? (
                <>
                  <div className="hidden md:flex md:relative md:left-[-1px] ">
                    <ArrowStepIndicatorLightDark width={'24'} height={'67'} />
                  </div>
                  {/* shape sett & cplt, case 2 */}
                  <div className="flex relative md:hidden">
                    <ArrowStepIndicatorLightDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              ) : isActiveComplete ? (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkLight width={'24'} height={'67'} />
                  </div>
                  {/* shape any & cplt, case 3 / case 6 */}
                  <div className="flex relative md:hidden left-[5px]">
                    <ArrowStepIndicatorDarkLightMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="hidden md:flex md:relative md:left-[1px]">
                    <ArrowStepIndicatorDarkDark width={'24'} height={'67'} />
                  </div>
                  {/* shape any & cplt, case 1 / case 4 */}
                  <div className="flex relative md:hidden">
                    <ArrowStepIndicatorDarkDarkMobile
                      width={'10'}
                      height={'47'}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex flex-1 flex-row justify-between">
              <StepComplete active={isActiveComplete} />
            </div>
          </>
        )}
      </>
    </div>
  )
}
export default StepIndicator
